import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createNewGoogleSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/google/slides/`,
  },
  createGoogleSlidePresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/google/presentations/`,
  },
  syncGoogleSlides: {
    method: 'POST',
    url: `${configs.baseLiveApiUrl}/api/stream/presenter/sync-google-slide`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createNewGoogleSlide = (params) => {
  return resource.createNewGoogleSlide(params)
}

const createGoogleSlidePresentation = async (params) => {
  const res = await resource.createGoogleSlidePresentation(params)
  return res.body
}

const syncGoogleSlides = async (params) => {
  const res = await resource.syncGoogleSlides(params)
  return res.body
}

export default {
  initResource,
  createNewGoogleSlide,
  createGoogleSlidePresentation,
  syncGoogleSlides,
}
